export const ORG_PLANNING_ROUTE = '/org-planning';
export const ORG_PLANS_ROUTE = '/plans';
export const ORG_PLAN_DEFAULT_VIEW = 'advanced';
export const ORG_PLAN_ENTRY_ROUTE = `${ORG_PLANNING_ROUTE}${ORG_PLANS_ROUTE}/:planId`;
export const ORG_PLAN_BUILDER_ROUTE = `${ORG_PLAN_ENTRY_ROUTE}/:nodeId/:view`;
export const ORG_PLAN_DETAILS_ROUTE = `${ORG_PLAN_BUILDER_ROUTE}/details/:targetEntityId`;

export type OrgPlanView = 'simple' | 'advanced';

export function getOrgPlanEntryRoute(planId: string) {
  return `${ORG_PLANNING_ROUTE}${ORG_PLANS_ROUTE}/${planId}`;
}

export function getOrgPlanBuilderRoute(
  planId: string,
  nodeId: string,
  view: OrgPlanView = ORG_PLAN_DEFAULT_VIEW,
) {
  return `${getOrgPlanEntryRoute(planId)}/${nodeId}/${view}`;
}

export function getOrgPlanDetailsRoute(
  planId: string,
  nodeId: string,
  targetEntityId: string,
  view: OrgPlanView = ORG_PLAN_DEFAULT_VIEW,
) {
  return `${getOrgPlanBuilderRoute(planId, nodeId, view)}/details/${encodeURIComponent(
    targetEntityId,
  )}`;
}

export const FILTER_OPTIONS = ['By Name', 'By Tag Name', 'By Person Name'];
export const SORT_OPTIONS = ['Name by A - Z', 'Name by Z - A', 'Last Updated'];
export const COMMENT_MAX_CHAR_LENGTH = 240;
